import { render, staticRenderFns } from "./commit_changes_modal.vue?vue&type=template&id=2def3da2&vue3"
import script from "./commit_changes_modal.vue?vue&type=script&lang=js&vue3"
export * from "./commit_changes_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports